import {formatearPorcentaje} from '../util/util';

const getIcon = (value, desc = false) => {
    let iconArrow;
    if (!desc) {
        if (value < 0.5) {
            iconArrow = "<i class=\"fa fa-circle danger\"></i> "
        } else if (value < 0.6) {
            iconArrow = "<i class=\"fa fa-circle warning\"></i> "
        } else {
            iconArrow = "<i class=\"fa fa-circle success\"></i> "
        }
    } else {
        if (value < 0.1) {
            iconArrow = "<i class=\"fa fa-circle success\"></i> "
        } else if (value < 0.2) {
            iconArrow = "<i class=\"fa fa-circle warning\"></i> "
        } else {
            iconArrow = "<i class=\"fa fa-circle danger\"></i> "
        }
    }
    return iconArrow;
};

export const porcentajeArrow = {
    inserted(el, binding) {
        binding.value = isNaN(binding.value) ? 0 : binding.value;
        el.innerHTML = getIcon(binding.value, binding.modifiers.desc) + formatearPorcentaje(binding.value, 1) + "%";
    },
    update(el, binding) {
        binding.value = isNaN(binding.value) ? 0 : binding.value;
        el.innerHTML = getIcon(binding.value, binding.modifiers.desc) + formatearPorcentaje(binding.value, 1) + "%";
    },
};




// WEBPACK FOOTER //
// ./src/directives/porcentajeArrow.js